/* Ube Time — comportement nav (hide on scroll, mobile menu, submenu) */
(function () {
  var wrap = document.getElementById('ubeNavWrap');
  var nav = document.getElementById('ubeNav');
  var burger = document.getElementById('ubeBurger');
  var mobile = document.getElementById('ubeMobileMenu');
  var closeBtn = document.getElementById('ubeCloseMenu');
  if (!wrap || !nav) return;

  var lastY = 0;
  var ticking = false;
  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    if (y > 10) { nav.classList.add('scrolled'); } else { nav.classList.remove('scrolled'); }
    if (y > lastY && y > 260) { wrap.classList.add('hide'); } else { wrap.classList.remove('hide'); }
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });

  function openMenu() { if (mobile) { mobile.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeMenu() { if (mobile) { mobile.classList.remove('open'); document.body.style.overflow = ''; } }
  if (burger) burger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (mobile) {
    mobile.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
  }

  // Panier : ouvre le tiroir Dawn si présent, sinon va vers /cart (icône ET bouton Acheter)
  document.querySelectorAll('[data-ube-cart]').forEach(function (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        drawer.open(cartBtn);
      }
    });
  });

  // Badge panier en temps réel : on met à jour le compteur après chaque opération panier
  function updateCartBadge(count) {
    document.querySelectorAll('.ube-cart-badge').forEach(function (b) {
      b.textContent = count;
      b.classList.toggle('show', count > 0);
    });
    document.querySelectorAll('[data-ube-cart]').forEach(function (a) {
      if (a.hasAttribute('aria-label')) a.setAttribute('aria-label', 'Panier (' + count + ')');
    });
  }
  function refreshCartBadge() {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartBadge(c.item_count); })
      .catch(function () {});
  }
  // Intercepte les requêtes panier de Dawn (fetch) pour rafraîchir le badge sans recharger
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      return _fetch.apply(this, args).then(function (res) {
        try {
          var u = (args[0] && args[0].url) ? args[0].url : args[0];
          if (typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(u)) {
            setTimeout(refreshCartBadge, 80);
          }
        } catch (e) {}
        return res;
      });
    };
  }
  // Écoute aussi les événements Dawn éventuels + état initial
  document.addEventListener('cart:refresh', refreshCartBadge);
  refreshCartBadge();

  // Sélecteur de langue : ouverture au clic
  document.querySelectorAll('.ube-lang').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var item = btn.closest('.ube-nav-item');
      if (item) item.classList.toggle('open');
      btn.setAttribute('aria-expanded', item && item.classList.contains('open') ? 'true' : 'false');
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.ube-lang-item')) {
      document.querySelectorAll('.ube-lang-item.open').forEach(function (i) { i.classList.remove('open'); });
    }
  });

  // Sous-menu Produits : clic/clavier (le survol est géré en CSS)
  document.querySelectorAll('.ube-nav-item > .prod-toggle').forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      t.parentElement.classList.toggle('open');
    });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.parentElement.classList.toggle('open'); }
    });
  });
})();
